import { render } from "./SelectTruckView.vue?vue&type=template&id=2a788afe&scoped=true"
import script from "./SelectTruckView.vue?vue&type=script&lang=js"
export * from "./SelectTruckView.vue?vue&type=script&lang=js"

import "./SelectTruckView.vue?vue&type=style&index=0&id=2a788afe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a788afe"]])

export default __exports__